<template>
    <div>
        <my_menu2 page_name="个税核算队列管理" back_type="close" back_icon="md-close">
        </my_menu2>
        <div style="height: 50px;"></div>
        <div class="search_box">
            <div>
                <span class="search_txt">
                    筛选主体：
                </span>
                <Select v-model="select_subject_id" style="width:150px" clearable filterable size="small">
                    <Option v-for="item in subject_options_list" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
            <div style="margin-left:10px">
                <span class="search_txt">
                    筛选项目：
                </span>
                <Input size="small" v-model="search_project_name" placeholder="筛选项目" style="width: 100px" />

            </div>
            <div>
                <span class="search_txt" style="margin-left:10px">
                    筛选年月：
                </span>
                <DatePicker type="month" v-model="select_year_month" placeholder="请选择" size=small
                    style="width: 100px" />
            </div>
            <div>
                <Button type="primary" size="small" style="font-size:13px;margin-left:10px"
                    @click="search_btn">筛选</Button>
                <Button size="small" style="font-size:13px;margin-left:10px" @click="export_data">
                    <Icon type="ios-cloud-download-outline" />
                    导出数据
                </Button>
            </div>
            <!-- <div>
                <Button size="small" style="font-size:13px;margin-left:10px" @click="shenbao_switch">
                    <Icon type="md-cog" />
                    核算开关
                </Button>
            </div> -->
            <div>
                <Button size="small" type="warning" style="font-size:13px;margin-left:10px" @click="import_zaizhi">
                    核算开关及信息导入
                </Button>
            </div>


        </div>
        <div class="main">
            <Table :columns="columns" :data="table_data" size="small" :height="windowHeight - 135">
                <template #cesuan_finish_msg="{ row }">
                    <div @click='view_msg(row)' class="view_msg1" v-if="row.cesuan_status == 2">
                        {{ row.cesuan_finish_msg ? '失败,' + row.cesuan_finish_msg.substring(0, 8) : '完成' }}
                        <Icon v-if="row.cesuan_finish_code != 1 && row.cesuan_finish_code != 0"
                            :title="row.cesuan_finish_msg" class="viewmsg" type="md-alert" color="red" size="18" />
                    </div>
                </template>
                <template #sixty_count_fmt="{ row }">
                    <div v-if="row.sixty_count > 0" class="sixty_count_fmt" @click="click_sixty(row)">
                        {{ row.sixty_count_fmt }}
                        <Icon :title="row.sixty_count_fmt" class="viewmsg" type="md-alert" color="red" size="18" />
                    </div>
                    <div v-else>
                        无
                    </div>
                </template>
                <template #detail="{ row }">
                    <div class="detail_div">
                        <Button @click="click_detail(row)" size="small" type="primary"
                            style="font-size: 12px;margin-right:3px">详情({{ row.people_count }}人)</Button>
                        <span @click="down_file(row)" class="file_down_span">
                            <Icon type="ios-cloud-download-outline" />原表
                        </span>
                    </div>
                </template>
                <template #reset="{ row }">

                    <span @click="reset_submit(row)" class="reset_submit">重试</span>

                </template>
                <template #delete="{ row }">

                    <span @click="delete_row(row)" class="delete_span">删除</span>

                </template>
            </Table>
            <div class="page_div">
                <div></div>
                <Page show-total :total="total_count" :page-size="20" @on-change="page_change" />
                <div></div>
            </div>
        </div>

        <Drawer title="个税核算开关" :closable="true" v-model="subject_cesuan_show" width="400">

            <div class="cesuan_tishi">
                主体后的开关如关闭，个税核算将无法提交，如不想让驻厂提交可先关闭，之后再打开
            </div>
            <div>
                <div v-for="(item, i) in subject_cesuan_list" :key="i" class="cesuan_switch_div">
                    <div class="switch_project_name">
                        {{ item.label }}
                    </div>
                    <div>
                        <Switch v-model="item.status" @on-change="shenbao_switch_change(item)" />

                    </div>
                </div>

            </div>
        </Drawer>

        <Drawer title="个税核算详情" :closable="true" v-model="cesuan_detail_show" width="95">
            <Spin fix v-if="cesuan_detail_loading">加载中...</Spin>

            <div>
                <div class="export_div">
                    <div class="export_btn" @click="export_detail_xls">
                        <Icon type="ios-cloud-download-outline" />导出核算后表格
                    </div>
                </div>

                <div>
                    <Table :height="windowHeight - 140" ref="table2" size="small" :columns="columns2" show-summary
                        :data="table_data2">
                    </Table>
                </div>

            </div>
        </Drawer>
        <Modal v-model="cesuan_finish_msg_show" title="任务结束-状态详情" :mask-closable="false" :footer-hide="true"
            :closable="true" width="600">
            <div class="img_miaoshu" v-if="cesuan_finish_item.back_img">
                图片描述：
                <div @click="view_back_img(cesuan_finish_item.back_img)" class="view_back_img2">
                    <img :src="cesuan_finish_item.back_img" alt="" style="width:80px;height:40px;" class="back_img1">
                </div>
            </div>

            <div class="finish_msg3">
                {{ cesuan_finish_item.cesuan_finish_msg }}
            </div>
        </Modal>
        <Modal v-model="sixty_show" title="算个税重要提示" ok-text="导出未算数据" @on-ok="download_sixty_data">
            <div> {{ sixty_down_item.sixty_name_list }} </div>
            <div class="sixty_span">以上人员是按年6万额扣除个税，无法自动算税，请联系财务手动计算这几个人的数据，其余数据计算完毕，可正常使用。</div>
        </Modal>
        <Modal v-model="export_finance_show" title="个税数据批量导出" :mask-closable="false" :footer-hide="true"
            :closable="true" width="600">
            <div>
                <div class="tishi2">
                    请筛选数据后再进行导出，同一身份证多条数据的仅保留时间最近的一条
                </div>
                <div class="down_btn_div2">
                    <Button :loading="export_finance_loading" type="primary" style="font-size: 13px;"
                        @click="export_data_request">确认导出数据</Button>
                </div>
                <div class="export_finance_div" v-if="export_finance_object_name">
                    <div>
                        <div>
                            数据所属年月：<span v-if="select_year_month">{{ select_year_month.getFullYear() }}-{{
                                select_year_month.getMonth() + 1 }}</span>
                            <span v-else>未筛选，全部数据</span>
                        </div>
                        <div>
                            导出数据总人数：{{ export_finance_original_length }}
                        </div>
                        <div>
                            身份证去重后人数：{{ export_finance_count }}
                        </div>
                        <div>
                            文件已经生成，<span @click="down_export_file" class="down_btn">点击下载</span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>


        <Modal v-model="zaizhi_import_show" title="主体-境内人员在职数据导入与核算开关" :mask-closable="false" :footer-hide="true"
            :closable="true" width="800">
            <div class="import_zaishi_tishi">
                每月个税申报结束后，从税务扣缴端导出境内人员在职数据表，在这里导入。导入后将覆盖掉原有的在、离职数据
            </div>
            <div>
                <div v-for="(item, i) in subject_cesuan_list" :key="i" class="upload_zaizhi">
                    <div class="switch_project_name">
                        {{ item.label }}
                    </div>
                    <div class="update_ziazhi_div">
                        <div class="hesuan_switch_div">
                            核算开关：
                            <Switch size="small" v-model="item.status" @on-change="shenbao_switch_change(item)" />
                        </div>

                        <Upload :show-upload-list=false :action="upload_file_url + '&subject_id=' + item.value" ref="i"
                            :on-success='upload_success'>
                            <Button :loading="upload_zaizhi_loading[item.value]" size='small' style="font-size: 13px;"
                                @click="click_upload_ziazhi(item)" icon="ios-cloud-upload-outline">上传更新在职名单</Button>
                        </Upload>
                        <div class="update_ziazhi_spam">
                            当前在职：{{ item.ziazhi_count }}人
                        </div>

                    </div>
                </div>

            </div>

        </Modal>
    </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { download_file, get_view_file_url, http, open_new_page } from "@/utils/http.js";

export default {
    components: {
        my_menu2,
    },
    data() {


        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度
            columns: [],
            table_data: [],
            cesuan_finish_msg_show: false,
            cesuan_finish_item: {},
            columns2: [],
            table_data2: [],
            cesuan_detail_show: false,
            total_count: 0,
            page: 1,
            sixty_show: false,
            sixty_down_item: {},
            cesuan_detail_loading: false,
            export_object_name: '',
            export_item: {},
            subject_options_list: [],
            select_subject_id: '',
            select_year_month: '',
            search_project_name: "",
            export_finance_show: false,
            export_finance_count: 0,
            export_finance_original_length: 0,
            export_finance_object_name: "",
            export_finance_loading: false,

            subject_cesuan_list: [],
            subject_cesuan_show: false,
            zaizhi_import_show: false,

            upload_file_url:
                process.env.VUE_APP_HOST +
                "/finance/itax/update_subject_zaizhi?token=" +
                this.$cookies.get("dx_token"),
            upload_zaizhi_loading: {},


        }
    },
    mounted() {
        this.get_data_list()
        this.get_options_subject()
    },

    methods: {

        delete_row(row) {
            var that = this;
            this.$Modal.confirm({
                title: '提示',
            content: `<p>你正在删除【${row.project_name}】【测算ID:${row.cesuan_id}，人数:${row.people_count}】测算数据，删除后无法撤销，是否继续？</p>`,
                onOk: () => {
                    var obj = {
                        cesuan_id: row.cesuan_id,
                    };
                    http("post", process.env.VUE_APP_HOST + "/finance/itax/task_delete", obj, true)
                        .then((res) => {
                            if (res.code == 0) {
                                that.$Message.success({
                                    content: res.msg,
                                    duration: 3,
                                });
                                that.get_data_list()

                            } else {
                                that.$Message.error({
                                    content: res.msg,
                                    duration: 3,
                                });
                            }
                        })
                        .catch((res) => {
                            console.log(res, "请求出错");
                        });
                },
                onCancel: () => {

                }
            });


        },
        click_upload_ziazhi(item) {
            this.upload_zaizhi_loading[item.value] = true
        },

        upload_success(e) {
            console.log(e)
            this.upload_zaizhi_loading[e.data.subject_id] = false
            if (e.code == 0) {
                this.$Message.success({
                    content: e.msg,
                    duration: 13
                }
                )
            } else {
                this.$Message.error({
                    content: e.msg,
                    duration: 10
                }
                )
            }

        },
        import_zaizhi() {
            this.zaizhi_import_show = true
            this.upload_zaizhi_loading = {}
        },
        // 重新提交
        reset_submit(row) {
            var that = this;
            var obj = {
                cesuan_id: row.cesuan_id,
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/geshui_hesuan_reset", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        shenbao_switch_change(item) {
            console.log(item)
            var that = this;
            var obj = {
                value: item.status,
                subject_id: item.value
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/subject_cesuan_close", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_options_subject()



                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        shenbao_switch() {
            this.get_options_subject()
            this.subject_cesuan_show = true
        },

        down_export_file() {
            get_view_file_url(this.export_finance_object_name)
        },
        click_sixty(item) {
            this.sixty_down_item = item
            this.sixty_show = true
            // var sixty_name_list = item.sixty_name_list
            // const str2 = sixty_name_list.join();
            // this.$Modal.confirm({
            //     title: '提示',
            //     content: '<div>' + str2 + '</div><div>以上人员是按年6万额扣除个税，无法自动算税，请联系财务手动计算这几个人的数据，其余数据计算完毕，可正常使用。</div>',
            //     onOk: () => {
            //         this.download_sixty_data(item.sixty_id_list)
            //     },
            //     onCancel: () => {
            //     }
            // });
        },
        view_back_img(url) {
            this.$ImagePreview.show({
                previewList: [url]
            });
        },
        get_options_subject() {
            var that = this;
            var obj = {
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/task_subject_list", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        this.subject_options_list = res.data.options_list
                        this.subject_cesuan_list = res.data.cesuan_list



                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        download_sixty_data() {
            var that = this;
            var obj = {
                sixty_id_list: this.sixty_down_item.sixty_id_list
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/download_sixty_xls", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        var object_name = res.data.object_name
                        that.$Modal.confirm({
                            title: '提示',
                            content: '<p>导出成功，是否下载</p>',
                            onOk: () => {
                                get_view_file_url(object_name)
                            },
                            onCancel: () => {
                                th
                            }
                        });


                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        export_detail_xls() {
            this.click_detail(this.export_item, 1)
        },
        down_file(row) {
            get_view_file_url(row.file)
        },

        view_msg(row) {
            this.cesuan_finish_msg_show = true

            this.cesuan_finish_item = row

        },
        page_change(e) {
            this.page = e
            this.get_data_list()
        },
        click_detail(row, is_download) {
            this.table_data2 = []
            this.columns2 = []
            this.cesuan_detail_show = true
            this.cesuan_detail_loading = true
            this.export_item = row
            var that = this;
            if (is_download == 1) {
                this.$Message.info('正在导出，请稍等')
            }
            var obj = {
                cesuan_id: row.cesuan_id,
                is_download: is_download
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/suanshui_detail", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns2 = res.data.columns
                        that.table_data2 = res.data.table_data
                        that.export_object_name = res.data.object_name
                        if (that.export_object_name != '' && is_download == 1) {
                            get_view_file_url(that.export_object_name)
                        }
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.cesuan_detail_loading = false

                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        search_btn() {
            this.page = 1
            this.get_data_list();
        },
        get_data_list() {
            var that = this;
            if (this.select_year_month) {
                var year = this.select_year_month.getFullYear();
                var month = this.select_year_month.getMonth() + 1
            } else {
                var year = 0
                var month = 0
            }
            var obj = {
                page: this.page,
                subject_id: this.select_subject_id,
                year: year,
                month: month,
                search_project_name: this.search_project_name
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/task_list", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns = res.data.columns
                        that.table_data = res.data.table_data
                        that.total_count = res.data.total_count
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        export_data() {
            this.export_finance_show = true
            this.export_finance_object_name = ''

        },
        export_data_request() {
            var that = this;
            this.export_finance_loading = true
            if (this.select_year_month) {
                var year = this.select_year_month.getFullYear();
                var month = this.select_year_month.getMonth() + 1
            } else {
                var year = 0
                var month = 0
            }
            var obj = {

                subject_id: this.select_subject_id,
                year: year,
                month: month
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/task_export", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        console.log(res)
                        this.export_finance_original_length = res.data.original_length
                        this.export_finance_count = res.data.count
                        this.export_finance_object_name = res.data.object_name
                        this.export_finance_loading = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });

        }
    }
}
</script>

<style scoped>
.delete_span {
    color: red;
    cursor: pointer;
}

.reset_submit {
    cursor: pointer;
}

.reset_submit:hover {
    color: #2e4bb2;
    cursor: pointer;

}

.hesuan_switch_div {
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.import_zaishi_tishi {
    font-size: 13px;
    color: #fff;
    background-color: rgb(255, 63, 63);
    padding: 10px;
    margin-bottom: 10px;
}

.upload_zaizhi {
    padding: 10px 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ececec;
    ;


}

.upload_zaizhi:hover {
    background-color: #f5f9fd;
    cursor: pointer;
}

.update_ziazhi_spam {
    margin-left: 10px;
}

.update_ziazhi_div {
    display: flex;
    align-items: center;
}

.cesuan_switch_div {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dfdfdf;
    padding: 3px;
}

.switch_project_name {
    width: 200px;
    flex-shrink: 0
}

.cesuan_tishi {
    font-size: 13px;
    background-color: #ffe4e4;
    padding: 5px;
    border-radius: 5px;
    margin-bottom: 10px;
}


.down_btn_div2 {
    display: flex;
    justify-content: center;
    padding: 10px;

}

.tishi2 {
    padding: 10px;
    background-color: #f0f7ff;
    margin-bottom: 10px;
}


.export_finance_div {
    font-size: 13px;
    display: flex;
    justify-content: center;
    margin: 10px;
    padding: 10px;
    border: solid 1px #ccc
}

.down_btn {
    cursor: pointer;
    color: #0173ff;
}

.search_txt {
    font-size: 13px;
    color: #333;

}

.search_box {
    margin: 0 10px 10px 10px;
    display: flex;
    align-items: center;
}

.detail_div {
    display: flex;
    align-items: center;
}

.view_back_img2:hover {
    cursor: pointer;
    border: 2px solid #0173ff
}


.export_btn {
    color: #0466dd;
    cursor: pointer;
    padding-bottom: 3px;
}

.export_div {
    display: flex;
    justify-content: end;
}

.sixty_span {
    margin-top: 10px;
    padding: 5px;
    border: 1px solid red;
    color: red;
}

.page_div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 10px;
    padding-top: 5px;
}

.file_down_span {
    font-size: 12px;
    margin-left: 3px;
    cursor: pointer;
    color: #5e5e5e
}

.file_down_span:hover {
    color: #0173ff
}

.img_miaoshu {
    display: flex;

}

.finish_msg3 {
    color: #666;
    font-size: 13px;
}

.view_msg1:hover {
    cursor: pointer;
    font-weight: 600;
    color: #333
}

.view_msg1 {
    color: #1163c8
}

.sixty_count_fmt:hover {
    font-weight: 600;
}

.sixty_count_fmt {
    color: red;
    cursor: pointer;
}

.export_data {
    cursor: pointer;
    color: #0173ff
}
</style>